/**
 * @description
 * !!!!!!!!!!所有的路由跳转都使用name，请确保所有name的唯一性!!!!!!!!!!!
 *
 * 目前只做了web路由的下拉最多一级，父级节点必须拥有redirect属性
 * meta{
 *  title {String} 菜单的标题
 *  icon {String}  菜单的图标class
 *  hideInMenu {false} 设置为true之后在菜单栏不会显示
 *  access {Array} 允许访问的权限[web]普通用户用户/高级用户, [admin]管理员，默认为空所有用户都可以访问
 * }
 */
import moduleHome from '@/components/public/home';
export default [{
    path: '/',
    name: 'index',
    redirect: {
      name: 'home'
    },
    component: () => import("@/components/client/page/login"),
    children: [{
        path: 'home',
        name: 'home',
        meta: {
          title: '首页'
        },
        component: () => import("@/components/client/page/section")
      }/* ,
      {
        path: 'experience',
        name: 'experience',
        meta: {
          title: '线上体验',
          href: 'https://www.deepcam.cn/index.php?a=lists&catid=54'
        }
      } */,
      {
        path: 'learn',
        name: 'learn',
        meta: {
          title: '学习中心',
          href: {
            'zh-CN': 'http://cnlearn.linksprite.com/',
            'en-US': 'http://learn.linksprite.com/'
          }
        }
      }
    ]
  },
  {
    path: '/web',
    name: 'web',
    redirect: {
      name: 'app'
    },
    component: moduleHome,
    children: [{
        path: 'app/',
        name: 'app',
        meta: {
          title: '应用管理',
          access: ['web'],
          icon: 'iconfont icon-icon_yingyongguanli'
        },
        component: () => import("@/components/web/app/app")
      },
      {
        path: 'app/device/:app_id',
        name: 'device',
        meta: {
          hideInMenu: true,
          title: '应用设备'
        },
        component: () => import("@/components/web/app/device")
      },
      {
        path: 'sdk',
        name: 'sdk',
        meta: {
          title: 'SDK中心',
          access: ['web'],
          icon: 'iconfont icon-shebeikaifa'
        },
        component: () => import("@/components/web/sdk/sdk")
      },
      {
        path: 'announcement',
        name: 'announcement',
        meta: {
          title: '公告中心',
          access: ['web'],
          icon: 'iconfont icon-gonggao'
        },
        component: () => import("@/components/web/announcement/announcement")
      },
      {
        path: 'personal',
        name: 'personal',
        meta: {
          title: '个人中心',
          access: ['web'],
          icon: 'iconfont icon-icon03'
        },
        component: () => import("@/components/web/personal/personal")
      }
    ]
  }, {
    path: '/admin',
    name: 'admin',
    redirect: '/admin/user',
    component: moduleHome,
    children: [{
        path: 'user',
        name: 'user',
        meta: {
          title: '用户管理',
          access: ['admin','enterprise'],
          icon: 'iconfont icon-yonghuguanli'
        },
        component: () => import("@/components/admin/user/user")
    },
    {
      path: 'app',
      name: 'adminapp',
      meta: {
        title: '应用管理',
        access: ['admin','enterprise'],
        icon: 'iconfont icon-icon_yingyongguanli'
      },
      redirect: {
        name:'appList'
      },
      component: () => import("@/components/public/jump"),
      children: [{
        path: 'appList',
        name: 'appList',
        meta: {
          title: '应用列表',
          access: ['admin','enterprise']
        },
        component: () => import("@/components/admin/app")
      },{
        path: 'warrant',
        name: 'warrant',
        meta: {
          title: '授权文件列表',
          access: ['admin','enterprise']
        },
        component: () => import("@/components/admin/app/warrant")
      }]
    },
      {
        path: 'sdkManagement',
        name: 'sdkManagement',
        meta: {
          title: 'SDK管理',
          access: ['admin','enterprise'],
          icon: 'iconfont icon-shebeikaifa'
        },
        redirect: {
          name:'sdkList'
        },
        component: () => import("@/components/public/jump"),
        children: [{
          path: 'sdkList',
          name: 'sdkList',
          meta: {
            title: 'SDK列表',
            access: ['admin','enterprise']
          },
          component: () => import("@/components/admin/sdk/list")
        },{
          path: 'sdkFiles',
          name: 'sdkFiles',
          meta: {
            title: 'SDK文件',
            access: ['admin']
          },
          component: () => import("@/components/admin/sdk/file")
        }]
      },
      {
        path: 'relationship',
        name: 'relationship',
        meta: {
          title: '设置关联',
          access: ['admin','enterprise'],
          icon: 'iconfont icon-association'
        },
        component: () => import("@/components/admin/relationship/association")
      }
    ]
  }, {
    path: '/login',
    name: 'login',
    component: () => import("@/components/client/page/login")
  }, {
    path: '/oblivion',
    name: 'oblivion',
    component: () => import("@/components/client/page/oblivion")
    }, {
    path: '/register',
    name: 'register',
    component: () => import("@/components/client/page/register")
  },
  {
    path: '/401',
    name: '401',
    component: () => import('@/components/error/401')
  },
  {
    path: '/500',
    name: '500',
    component: () => import('@/components/error/500')
  },
  {
    path: '*',
    name: '404',
    component: () => import('@/components/error/404')
  }
]



// WEBPACK FOOTER //
// ./src/router/routes.js